/* eslint-disable */
import React,{useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css'; // We'll add raw CSS here
import './styles/global.css'; // Global styles
import Header from './components/Header/Header';
import AccountSettings from './pages/AccountSettings/AccountSettings';
import ResourceDetail from './pages/ResourceDetail/ResourceDetail';
import SubmitResource from './pages/SubmitResource/SubmitResource';
import ResourceCollections from './pages/ResourceCollections/ResourceCollections';
import SearchResults from './pages/SearchResults/SearchResults';
import SupportDirectory from './pages/SupportDirectory/SupportDirectory';
import MyResources from './pages/MyResources/MyResources';
import Homepage from './pages/Homepage/Homepage';
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import OrganizationDetail from './pages/OrganizationDetail/OrganizationDetail';
import CollectionDetail from './pages/CollectionDetail/CollectionDetail';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Register from './pages/Register/Register';

// Simple navigation wrapper to handle links
const NavLink = ({ to, children, className = '' }) => {
  const navigate = useNavigate();
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        navigate(to);
      }}
      className={className}
    >
      {children}
    </a>
  );
};
// src/App.jsx (add this)




function App() {
  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      // User signed in – store UID
      console.log('User UID:', user.uid);
      // e.g. setUserId(user.uid) in context
    } else {
      // Signed out
    }
  });
  return unsubscribe;
}, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route path="/" element={<Homepage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/collections" element={<ResourceCollections />} />
          
          {/* <Route path="/collections/:slug" element={<CollectionDetail />} /> */}
           <Route path="/collections/:slug" element={<CollectionDetail />} />
          <Route path="/resource/:id" element={<ResourceDetail />} />
          <Route path="/submit-resource" element={<SubmitResource />} />
          <Route path="/support" element={<SupportDirectory />} />
          <Route path="/support/:orgSlug" element={<OrganizationDetail />} />

          {/* Authenticated / user pages */}
          <Route path="/my-resources" element={<MyResources />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Auth pages */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}

          {/* Catch-all 404 */}
          <Route path="*" element={<Homepage />} />
          {/* <Route index element={<Homepage />} />
          <Route path="my-resources" element={<MyResources />} />
          <Route path="support" element={<SupportDirectory />} />
          <Route path="collections" element={<ResourceCollections />} />
          <Route path="*" element={<Homepage />} /> */}
        </Route>
      </Routes>
    </Router>
  );
}


// function App() {
//   return (
    
//       <Router>
//       <Layout>
//         <Routes>
//              <Route path="/" element={<Homepage />} />
//           <Route path="/search" element={<SearchResults />} />
//           <Route path="/resource/:id" element={<ResourceDetail />} />
//           <Route path="/account" element={<AccountSettings />} />
//           <Route path="/submit" element={<SubmitResource />} />
//           <Route path="/collections" element={<ResourceCollections />} />
//           <Route path="/support" element={<SupportDirectory />} />
//           <Route path="/my-resources" element={<MyResources />} />
//           {/* Default to account settings for demo */}
//           <Route path="*" element={<AccountSettings />} />

//           {/* <div className="min-h-screen bg-[#FAFBFC] font-sans" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
//         <Header />
//         <Layout />
//         <Routes>
//           <Route path="/" element={<Homepage />} />
//           <Route path="/search" element={<SearchResults />} />
//           <Route path="/resource/:id" element={<ResourceDetail />} />
//           <Route path="/account" element={<AccountSettings />} />
//           <Route path="/submit" element={<SubmitResource />} />
//           <Route path="/collections" element={<ResourceCollections />} />
//           <Route path="/support" element={<SupportDirectory />} />
//           <Route path="/my-resources" element={<MyResources />} />
          
//           <Route path="*" element={<AccountSettings />} />
//         </Routes>
//       </div> */}

      
//         </Routes>
//       </Layout>

      
//     </Router>
//   );
// }

export default App;